import * as React from 'react';

import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';
import {dateLastUpdated} from '@app/components/Pages/Policies/PrivacyPolicy';

const SiteAccessibility = () => {
	return (
		<div className="policies">
			<div className="middle-text__text">
				<p>
					<b>{dateLastUpdated()}</b>
				</p>
			</div>
			<div className="middle-text__text">
				<p>Lap of Love aims to make its site accessible to all visitors, including those who have visual or
					other disabilities that could affect their browsing experience.</p>
				<p>
					Lap of Love has adopted the Worldwide Web Consortium Web Content Accessibility Guidelines version
					2.0, Level AA Conformance as its goal. This means we aim to make our site:
				</p>

				<ul>
					<li>Perceivable (able to be viewed and read)</li>
					<li>Operable (able to be browsed)</li>
					<li>Understandable (predictable and easy to use)</li>
					<li>Robust (compatible with as many browsing methods as possible)</li>
				</ul>
			</div>
			<div className="middle-text__text">
				<p>We are committed to making a good faith effort to meet the above standards on our site, and we are
					continuing to implement new features to increase our support of all users.</p>
				<p>
					If you are experiencing any difficulty at all in browsing or understanding our site, or would like
					to suggest a way in which our site could be more accessible, please email us at{' '}
					<a
						href="mailto:Support@LapofLove.com"
						className="inline-link">Support@LapofLove.com</a> or call us at <a
					href={'tel:855-933-5683'}
					className="inline-link">855-933-5683</a> and
					we will do our best to address your concerns
					and/or provide you with an alternate method of accessing our content which meets your needs.
				</p>
			</div>
		</div>
	);
};

export default withSeo(SiteAccessibility, state => state.accessibilityPolicyPage, 'accessibilityPolicyPage', 'policies/accessibility-policy');